module.exports = require("xlsx");


//////////////////
// WEBPACK FOOTER
// external "xlsx"
// module id = 102
// module chunks = 0